import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { HOME } from "@/lib/media";
const ArrowIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};

/** Server-rendered hero — no opacity-0 animations (LCP-safe). */
export default function Hero() {
  const $ = _c(8);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 z-0"><img src={HOME.bannerHero} alt={HOME.bannerHeroAlt} fetchPriority="high" loading="eager" decoding="sync" width={1920} height={1080} className="hero-lcp-img absolute inset-0 w-full h-full object-cover object-center" /></div>;
    t1 = <div className="absolute inset-0 bg-[#0F1C2E]/70 z-[1]" aria-hidden="true" />;
    t2 = <div className="absolute inset-0 bg-gradient-to-t from-[#0F1C2E] via-transparent to-black/40 z-[1]" aria-hidden="true" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center gap-2 sm:gap-3 mb-5 sm:mb-8"><div className="w-5 sm:w-8 h-px bg-[#C9A84C]" /><span className="font-body text-[10.5px] md:text-[11.5px] tracking-[0.25em] uppercase text-[#C9A84C] font-light">Est. Global Girmitiya Council</span><div className="w-5 sm:w-8 h-px bg-[#C9A84C]" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="block pb-1">Tracing the Journey</span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h1 className="font-display text-[36px] sm:text-[46px] md:text-[72px] lg:text-[88px] font-light leading-[1.05] tracking-[-0.02em] text-[#F4EFE6] mb-5 sm:mb-8">{t4}<span className="block pb-1">of <span className="text-[#C9A84C] italic">Girmitiyas</span></span></h1>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="font-body text-[14px] sm:text-[16px] md:text-[18px] font-light leading-[1.7] sm:leading-[1.85] text-white/80 mb-6 sm:mb-10 max-w-[640px] px-2 sm:px-0">A global digital archive documenting the history, migration, and legacy of Indian indentured labourers across{" "}<em className="not-italic font-normal text-white">fifteen nations</em>. We preserve the voices of forgotten journeys to ensure their stories endure.</p>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <section className="hero-section font-body relative min-h-[480px] h-[65svh] md:h-[100svh] max-h-[750px] md:min-h-[550px] md:h-[650px] md:max-h-[750px] bg-[#0F1C2E] overflow-hidden flex flex-col justify-center items-center">{t0}{t1}{t2}<div className="relative z-10 w-full max-w-[1000px] mx-auto px-4 sm:px-6 md:px-8 flex flex-col items-center text-center pt-4 sm:pt-8 md:pt-12">{t3}{t5}{t6}<div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-3 sm:gap-4 w-full sm:w-auto"><Link href="/archives" className="font-body inline-flex items-center justify-center gap-2.5 px-7 py-3.5 sm:py-4 bg-[#C9A84C] text-[#0F1C2E] font-medium text-[11.5px] sm:text-[12.5px] tracking-[0.08em] uppercase hover:bg-white transition-colors duration-300 w-full sm:w-auto">Explore Archives<ArrowIcon /></Link><Link href="/reports" className="font-body inline-flex items-center justify-center gap-2.5 px-7 py-3.5 sm:py-4 border border-white/25 text-white text-[11.5px] sm:text-[12.5px] tracking-[0.08em] uppercase hover:border-white hover:bg-white/5 transition-colors duration-200 w-full sm:w-auto">Browse Reports</Link></div></div></section>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}